import { useMemo } from 'react';
import { useAppSelector, useSessionContext } from "../../../../../shared/model";
import { UserType } from "../../../../../shared/api";
import { selectUnreadedMessages } from "../../../../../entities/message/model";
import { selectAppersList } from "../../../../../entities/user/model";
import { findReplyedMessage, formatDate, getAnimalData, getDateDividerVisible, getMessageStage, isAuthorsDifferent } from "./helper";
export var useGroupedMessages = function useGroupedMessages() {
  var unreadedMessages = useAppSelector(selectUnreadedMessages);
  var animalData = useAppSelector(selectAppersList);
  var _useSessionContext = useSessionContext(),
    sessions = _useSessionContext.sessions;
  return useMemo(function () {
    var list = [];
    var activeIndex = -1;
    sessions.forEach(function (session, index) {
      session.messages.forEach(function (message, i) {
        var _previousSession$mess;
        var side = message.author.type === UserType.Client ? 'main' : 'opposite';
        var previousMessage = session.messages[i - 1];
        var nextMessage = session.messages[i + 1];
        var previousSession = sessions[index - 1];
        var previousLastDateMesSession = previousSession === null || previousSession === void 0 || (_previousSession$mess = previousSession.messages[previousSession.messages.length - 1]) === null || _previousSession$mess === void 0 ? void 0 : _previousSession$mess.date;
        var withDateDivider = getDateDividerVisible(message, (previousMessage === null || previousMessage === void 0 ? void 0 : previousMessage.date) || previousLastDateMesSession, i === 0, (previousSession === null || previousSession === void 0 ? void 0 : previousSession.updatedAt) || (previousSession === null || previousSession === void 0 ? void 0 : previousSession.updatetAt) // в старой версии history есть особенность на бэке/опечатка которую не поправить на их стороне
        );
        if (withDateDivider || activeIndex === -1) {
          activeIndex += 1;
          list.push({
            date: formatDate(message.date),
            list: []
          });
        }
        list[activeIndex].list.push({
          author: getAnimalData(message.author, animalData),
          side: side,
          message: message,
          stage: getMessageStage({
            message: message,
            unreadedMessages: unreadedMessages
          }),
          reply: findReplyedMessage(sessions, animalData, message.message.replyId),
          withUsername: withDateDivider || isAuthorsDifferent(previousMessage, message),
          withAvatar: withDateDivider || isAuthorsDifferent(message, nextMessage)
        });
      });
    });
    return list;
  }, [sessions, animalData, unreadedMessages]);
};